import React from 'react'
import './heartbeatTrends.module.scss'
import { isAgentLogin, isCarrierLogin } from 'tools/auth'
import { REPORT_KEYS } from 'constants/reporting'
import ConsoleEmbed from 'components/ConsoleEmbed'
import { useEnsureInvitingCompanyId } from 'hooks/useEnsureInvitingCompanyId'

interface IHeartbeatTrendsProps {
  print?: boolean
  useCarrierFilters: boolean
}

const HeartbeatTrendsDashboard: React.FC<IHeartbeatTrendsProps> = (props) => {
  const { useCarrierFilters } = props
  const ensuredInvitingCompanyId = useEnsureInvitingCompanyId()

  const isAgentOrCarrier = isCarrierLogin() || isAgentLogin()
  const invitingCompanyId = isAgentOrCarrier
    ? ensuredInvitingCompanyId
    : undefined
  const carrierId =
    useCarrierFilters && !isCarrierLogin()
      ? localStorage.getItem('carrierId') || undefined
      : undefined
  return (
    <ConsoleEmbed
      reportKey={REPORT_KEYS.FLEET_HEARTBEAT_TRENDS}
      invitingCompanyId={invitingCompanyId}
      carrierId={carrierId}
    />
  )
}
export default HeartbeatTrendsDashboard
